export default __webpack_public_path__ + "static/media/chata.8435d11b.jpeg";